import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SeguimientoPresupuestalRoutingModule } from './seguimiento-presupuestal-routing.module';
import { EstadosFinancierosComponent } from './estados-financieros/estados-financieros.component';
import { SharedModule } from '../../shared/shared.module';
import { PresupuestoIaService } from '../../services/segimiento-presupuestal/IA/presupuesto-ia.service';
import { PresupuestoManualService } from '../../services/segimiento-presupuestal/Manual/presupuesto-manual.service';
import { RazonesFinancierasComponent } from './razones-financieras/razones-financieras.component';
import { AnalisisSegmentoComponent } from './analisis-segmento/analisis-segmento.component';
import { AnalisisSucursalesComponent } from './analisis-sucursales/analisis-sucursales.component';
import { CatalogoCuentasComponent } from './catalogo-cuentas/catalogo-cuentas.component';


@NgModule({
  declarations: [
    EstadosFinancierosComponent,
    RazonesFinancierasComponent,
    AnalisisSegmentoComponent,
    AnalisisSucursalesComponent,
    CatalogoCuentasComponent
  ],
  imports: [
    CommonModule,
    SeguimientoPresupuestalRoutingModule,
    SharedModule,
  ],
  providers: [
    PresupuestoIaService,
    PresupuestoManualService,
  ]
})
export class SeguimientoPresupuestalModule { }
